import React from 'react';
import { CustomInput } from './CustomInput';
import PhoneInput from 'react-phone-number-input/input';
import { CustomInputChangeEvent } from '../../../utils/models/events/CustomInputChangeEvent';

interface CustomPhoneInputProps {
  // Forwarded to the rendered <input> (react-phone-number-input passes it to
  // inputComponent) so an InputWrapper label can point at the field.
  id?: string;
  placeholder?: string;
  name: string;
  onChange: (event: CustomInputChangeEvent) => void;
  onBlur?: React.FocusEventHandler<HTMLInputElement>;
  value: string;
  disabled: boolean;
  className?: string;
}

export function CustomPhoneInput({ id, onChange, onBlur, name, value, placeholder, disabled, className }: CustomPhoneInputProps) {
  function emitEvent(x: unknown) {
    onChange({
      target: {
        name: name,
        type: 'phone-input',
        // @ts-ignore
        value: x ? x.toString() : ''
      }
    });
  }

  return <PhoneInput
    id={id}
    placeholder={placeholder}
    name={name}
    value={value}
    inputComponent={CustomInput}
    onChange={emitEvent}
    onBlur={onBlur}
    smartCaret={true}
    className={className}
    disabled={disabled} />;
}
